module.exports = __webpack_public_path__ + "img/big_1_73.c4c8c84b.png";